export enum EErrorPartialMessages {
  MAX_ORDER_AMOUNT = 'Order subtotal exceeds the allowed maximum',
}
